/* eslint-disable */
/// This file is auto generated - do not edit manually
export const Last = 'Website.Paging.Last';
export const Next = 'Website.Paging.Next';
export const Page = 'Website.Paging.Page';
export const GoToPage = 'Website.Paging.GoToPage';
export const OutOf = 'Website.Paging.OutOf';
export const ManualSelect = 'Website.Paging.ManualSelect';
